import styled from '@emotion/styled';

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
  align-items: center;
`;

const Titulo = styled.div`
  min-width: 230px;
`;

const Iframe = styled.div`
  width: 100%;

  [data-lift='lft-skeleton'] {
    height: calc(100vh - 100px);
  }
`;

const S = {
  SkeletonContainer,
  Titulo,
  Iframe,
};

export default S;
